const Print = {
  init() {
    const params = {
      printable: null,
      fallbackPrintable: null,
      type: "pdf",
      header: null,
      headerStyle: "font-weight: 300;",
      maxWidth: 800,
      properties: null,
      gridHeaderStyle: "font-weight: bold; padding: 5px; border: 1px solid #dddddd;",
      gridStyle: "border: 1px solid lightgray; margin-bottom: -1px;",
      showModal: false,
      onError: error => {
        throw error;
      },
      onLoadingStart: null,
      onLoadingEnd: null,
      onPrintDialogClose: () => {},
      onIncompatibleBrowser: () => {},
      modalMessage: "Retrieving Document...",
      frameId: "printJS",
      printableElement: null,
      documentTitle: "Document",
      targetStyle: ["clear", "display", "width", "min-width", "height", "min-height", "max-height"],
      targetStyles: ["border", "box", "break", "text-decoration"],
      ignoreElements: [],
      repeatTableHeader: true,
      css: null,
      style: null,
      scanStyles: true,
      base64: false,
      // Deprecated
      onPdfOpen: null,
      font: "TimesNewRoman",
      font_size: "12pt",
      honorMarginPadding: true,
      honorColor: false,
      imageStyle: "max-width: 100%;"
    }; // Check if a printable document or object was supplied

    const args = arguments[0];

    if (args === undefined) {
      throw new Error("printJS expects at least 1 attribute.");
    } // Process parameters


    switch (typeof args) {
      case "string":
        params.printable = encodeURI(args);
        params.fallbackPrintable = params.printable;
        params.type = arguments[1] || params.type;
        break;

      case "object":
        params.printable = args.printable;
        params.fallbackPrintable = typeof args.fallbackPrintable !== "undefined" ? args.fallbackPrintable : params.printable;
        params.fallbackPrintable = params.base64 ? `data:application/pdf;base64,${params.fallbackPrintable}` : params.fallbackPrintable;

        for (const k in params) {
          if (k === "printable" || k === "fallbackPrintable") continue;
          params[k] = typeof args[k] !== "undefined" ? args[k] : params[k];
        }

        break;

      default:
        throw new Error(`Unexpected argument type! Expected "string" or "object", got ${typeof args}`);
    } // Validate printable


    if (!params.printable) throw new Error("Missing printable information."); // Check for a print start hook function

    if (params.onLoadingStart) params.onLoadingStart(); // To prevent duplication and issues, remove any used printFrame from the DOM

    const usedFrame = document.getElementById(params.frameId);
    if (usedFrame) usedFrame.parentNode.removeChild(usedFrame); // Create a new iframe for the print job

    const printFrame = document.createElement("iframe");
    printFrame.setAttribute("style", "visibility: hidden; height: 0; width: 0; position: absolute; border: 0"); // Set iframe element id

    printFrame.setAttribute("id", params.frameId); // For non pdf printing, pass an html document string to srcdoc (force onload callback)

    if (params.type !== "pdf") {
      printFrame.srcdoc = "<html><head><title>" + params.documentTitle + "</title>"; // Attach css files

      if (params.css) {
        // Add support for single file
        if (!Array.isArray(params.css)) params.css = [params.css]; // Create link tags for each css file

        params.css.forEach(file => {
          printFrame.srcdoc += `<link rel="stylesheet" href="${file}">`;
        });
      }

      printFrame.srcdoc += "</head><body></body></html>";
    }

    params.printableElement = document.createElement("div");
    params.printableElement.setAttribute("style", "width:100%"); // Set our raw html as the printable element inner html content

    params.printableElement.innerHTML = params.printable; // Print html contents

    return Print.send(params, printFrame);
  },

  send(params, printFrame) {
    return new Promise((resolve, reject) => {
      // Append iframe element to document body
      document.getElementsByTagName("body")[0].appendChild(printFrame); // Get iframe element

      const iframeElement = document.getElementById(params.frameId); // Wait for iframe to load all content

      iframeElement.onload = () => {
        // Get iframe element document
        let printDocument = iframeElement.contentWindow || iframeElement.contentDocument;
        if (printDocument.document) printDocument = printDocument.document; // Append printable element to the iframe body

        printDocument.body.appendChild(params.printableElement); // Add custom style

        if (params.type !== "pdf" && params.style) {
          // Create style element
          const style = document.createElement("style");
          style.innerHTML = params.style; // Append style element to iframe's head

          printDocument.head.appendChild(style);
        } // If printing images, wait for them to load inside the iframe


        const images = printDocument.getElementsByTagName("img");

        if (images.length > 0) {
          loadIframeImages(Array.from(images)).then(() => performPrint(iframeElement, params)).then(resolve).catch(reject);
        } else {
          performPrint(iframeElement, params).then(resolve, reject);
        }
      };
    });
  }

};

function performPrint(iframeElement, params) {
  return new Promise((resolve, reject) => {
    try {
      iframeElement.focus();
      iframeElement.contentWindow.print();
      resolve();
    } catch (error) {
      params.onError(error);
      reject(error);
    }
  });
}

function loadIframeImages(images) {
  // eslint-disable-next-line array-callback-return
  const promises = images.map(image => {
    if (image.src && image.src !== window.location.href) {
      return loadIframeImage(image);
    }
  });
  return Promise.all(promises);
}

function loadIframeImage(image) {
  return new Promise(resolve => {
    const pollImage = () => {
      (!image || !image.complete) && (typeof image.naturalWidth === "undefined" || image.naturalWidth === 0) ? setTimeout(pollImage, 500) : resolve();
    };

    pollImage();
  });
}

const printJS = (...args) => Promise.resolve(Print.init(...args));

if (typeof window !== "undefined") {
  window.printJS = printJS;
}

export default printJS;